import { atom } from "recoil";

export type ICategoryType = string;

export interface ICommunityCategory {
  no: number;
  type?: string;
  group_no?: number;
  category: string;
}

export interface ICommunityCategorySub {
  no?: number;
  category_no?: number;
  title?: string;
}

export interface ICommunityCategoryRequest extends ICommunityCategory {
  sub?: ICommunityCategorySub[];
  user_count?: number;
  new_count?: number;
}

export interface ICommunityGroup {
  no?: number;
  title?: string;
}

export const communityGroupState = atom<ICommunityGroup[]>({
  key: "communityGroupState",
  default: [],
});

export const communityCategoryState = atom<ICommunityCategoryRequest[]>({
  key: "communityCategoryState",
  default: [],
});
